import { Modal } from 'antd';
import React, { useCallback, useState } from 'react';
import {
  AssetCatalogResponse,
  ParAssetCatalogOptionResponse,
  ParAssetCatalogServiceResponse,
} from '../../services/assetconfig';
import AssetCatalogSingleItemDetails from './AssetCatalogSingleItemDetail';
import AssetCatalogSingleItem from './AssetCatalogSingleItem';

type AssetCatalogSingleItemDetailModalProps = {
  visible: boolean;
  item: AssetCatalogResponse;
  cataloglabel?: string;
  onCancel: () => void;
  currcode?: string;
  onSelect: (
    item: AssetCatalogResponse,
    selectedServices: ParAssetCatalogServiceResponse[],
    selectedOption: ParAssetCatalogOptionResponse[]
  ) => void;
  preview?: any;
};

const AssetCatalogSingleItemDetailModal = (
  props: AssetCatalogSingleItemDetailModalProps
) => {
  const { visible, onCancel, cataloglabel, currcode, onSelect, item, preview } =
    props;
  const [detailsVisible, setDetailsVisible] = useState(false);
  const closeDetails = useCallback(() => {
    setDetailsVisible(false);
  }, []);

  const openDetails = useCallback(() => {
    setDetailsVisible(true);
  }, []);

  return (
    <Modal
      visible={visible}
      title={
        item.catalogid +
        ' - ' +
        item.assetlabel +
        ' / ' +
        (item.assetmodellabel ? item.assetmodellabel : '')
      }
      footer={null}
      onCancel={onCancel}
      width="900px"
      style={{ borderBottom: '#DAF0EE', backgroundColor: '#f0f0f0' }}
    >
      {preview ? (
        <AssetCatalogSingleItem
          currcode={item.currcode}
          item={item}
          isModal
          onCancel={closeDetails}
          cataloglabel={item.assetlabel}
        />
      ) : (
        <AssetCatalogSingleItemDetails
          currcode={item.currcode}
          item={item}
          isModal
          onCancel={closeDetails}
        />
      )}
    </Modal>
  );
};

export default AssetCatalogSingleItemDetailModal;
